import { Chord, ClassicWaveform, dbToGain, FFT, gainToDb, midiToHz, PPQN } from "@opendaw/lib-dsp";
import { Sample } from "@opendaw/studio-adapters";
import { VoicingMode } from "@opendaw/studio-enums";
export { PPQN, FFT, Chord, Sample, dbToGain, gainToDb, midiToHz, ClassicWaveform, VoicingMode };
export var AudioPlayback;
(function (AudioPlayback) {
    AudioPlayback[AudioPlayback["NoWarp"] = 0] = "NoWarp";
    AudioPlayback[AudioPlayback["PitchStretch"] = 1] = "PitchStretch";
})(AudioPlayback || (AudioPlayback = {}));
